module.exports = __webpack_public_path__ + "media/exchange.5975e725.mp3";